<template>
    <ul class="c-single-car-features__list" v-if="loaded">

        <li v-if="currentTrim.moteur" class="c-single-car-features__list__item">
            <svgIco icon='moteur'/>
            <div class="c-single-car-features__list__text">
                <strong>Moteur</strong><br>
                <span>{{currentTrim.moteur}}</span>
            </div>
        </li>

        <li v-if="currentTrim.power" class="c-single-car-features__list__item">
            <svgIco icon='puissance'/>
            <div class="c-single-car-features__list__text">
                <strong>Puissance</strong><br>
                <span>{{currentTrim.power}}</span>
            </div>
        </li>

        <li v-if="getWheels()" class=" c-single-car-features__list__item">
            <svgIco icon='rouage'/>
            <div class="c-single-car-features__list__text">
                <strong>Rouage</strong><br>
                <span>{{getWheels()}}</span>
            </div>
        </li>


        <li class="c-single-car-features__list__item">
            <svgIco icon='transmission'/>
            <div class="c-single-car-features__list__text">
                <strong>Transmission</strong><br>
                <span>{{ currentTrim.name.match(/BM/) || currentTrim.name.match(/BVM/) ? 'Manuelle' : 'Automatique' }}</span>
            </div>
        </li>

        <li v-if="currentTrim.icone=='gas'" class="c-single-car-features__list__item">
            <svgIco icon='carburant-essence'/>
            <div class="c-single-car-features__list__text">
                <strong>Carburant</strong><br>
                <span>Essence</span>
            </div>
        </li>

        <li v-if="currentTrim.icone=='hybrid'" class="c-single-car-features__list__item">
            <svgIco icon='carburant-hybride' class='-hybride'/>
            <div class="c-single-car-features__list__text">
                <strong>Carburant</strong><br>
                <span>Hybride</span>
            </div>
        </li>

        <li v-if="currentTrim.icone=='recharge'" class="c-single-car-features__list__item">
            <svgIco icon='carburant-hybride-rechargeable' class='-hybride-recharge'/>
            <div class="c-single-car-features__list__text">
                <strong>Carburant</strong><br>
                <span>Hybride rechargeable</span>
            </div>
        </li>

        <li v-if="currentTrim.icone=='electric'" class="c-single-car-features__list__item">
            <svgIco icon='carburant-electrique'/>
            <div class="c-single-car-features__list__text">
                <strong>Carburant</strong><br>
                <span>Électrique</span>
            </div>
        </li>


        <li v-if="currentTrim.gas" class="c-single-car-features__list__item">
            <svgIco icon='consommation-essence'/>
            <div class="c-single-car-features__list__text">
                <strong>Consommation</strong><br>
                <span>{{currentTrim.gas}}</span><br>
                <span>Ville/Autoroute (L/100km)</span>
            </div>
        </li>

        <li v-if="currentTrim.auto" class="c-single-car-features__list__item">
            <svgIco icon='autonomie'/>
            <div class="c-single-car-features__list__text">
                <strong>Autonomie</strong><br>
                <span>{{currentTrim.auto}}</span>
            </div>
        </li>
        
        
        <!--li class="c-single-car-features__list__item">
            <svgIco icon='garantie' />
            <div class="c-single-car-features__list__text">
                <strong>Garantie</strong><br>
                <span>3 ans/60 000 km</span>
            </div>
        </li-->
        
        <li v-if="getCabine()" class="c-single-car-features__list__item">
            <svgIco icon='camion-cabine' class='-camion' />
            <div class="c-single-car-features__list__text">
                <strong>Cabine</strong><br>
                <span>{{getCabine()}}</span>
            </div>
        </li>

        <li v-if="getCaisse()" class="c-single-car-features__list__item">
            <svgIco icon='camion-boite' class='-camion' />
            <div class="c-single-car-features__list__text">
                <strong>Caisse</strong><br>
                <span>{{getCaisse()}}</span>
            </div>
        </li>

        <!--li class="c-single-car-features__list__item">
            <svgIco icon='camion-chassis' class='-camion' />
            <div class="c-single-car-features__list__text">
                <strong>Chassis</strong><br>
                <span>{{ 'x' }}</span>
            </div>
        </li-->

        
    </ul>
</template>

<script>
export default {
    name: 'NewCarFeatures',
    data() {
        return {
           currentTrim: {},
           currentOption: {},
           loaded: false,
        }
    },
    methods: {
       bind() {
            document.$on('trimChanged', (data) => {
                this.currentTrim = data.detail.trim;
                this.loaded = true;
            });
            document.$on('optionChanged', (data) => {
                this.currentOption = data.detail.option;
            });
        },
        getCabine() {
            if (this.currentTrim.cabine) {
                return this.currentTrim.cabine;
            }
            return '';
        },
        getCaisse() {
            if (this.currentTrim.caisse) {
                return this.currentTrim.caisse;
            }
            return '';
        },
        getWheels() {
            if (this.currentOption && this.currentOption.traction) {
                return this.currentOption.traction;
            }
            if (this.currentTrim.wheel) {
                return this.currentTrim.wheel;
            }
            return '';
        }
    },
    mounted() {
        this.bind();
    }
}
</script>